import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'
import timezone from 'dayjs/plugin/timezone'
import { DATE_TIME_FORMAT } from '@/const'
import { INewsProps } from '@/entities/News'
import News from '@/gateways/MicrocmsGateway/types/news'

dayjs.extend(utc)
dayjs.extend(timezone)

export function toNewsProps(data: News): INewsProps {
  const { id, content, title, category, startDateTime, endDateTime } = data

  function formatDate(dt: string | undefined): string {
    if (!dt) return ''
    const parsed = dayjs.utc(dt).tz('Asia/Tokyo')
    return parsed.format(DATE_TIME_FORMAT)
  }

  return {
    id,
    content,
    title,
    category: category || 3,
    startDateTime: formatDate(startDateTime),
    endDateTime: formatDate(endDateTime)
  }
}
